import { createDynamicSlice } from ".";
import { fetchFeedbackRequestsThunk } from "../thunks/feedbackRequestsThunk";

export const feedbackRequestsSlice = createDynamicSlice({
  name: "feedbackRequests",
  thunk: fetchFeedbackRequestsThunk,
  listMode: true,
  resetActionName: "resetFeedbackRequests",
});

export const feedbackRequestsReducer = feedbackRequestsSlice.reducer;
export const { resetFeedbackRequests } = feedbackRequestsSlice.actions;
